import React from 'react';
import { Link } from 'react-router-dom';
import './EventBanner.css';

const EventBanner = () => {
  return (
    <div className="event-banner">
      <div className="container">
        <div className="event-banner-content">
          <div className="event-banner-info">
            <div className="event-banner-badge">Upcoming Event</div>
            <h3 className="event-banner-title">Annual Global Freight Forwarders Conference</h3>
            <p className="event-banner-text">
              Connect with senior logistics professionals worldwide for strategic networking, collaboration, and business growth opportunities.
            </p>
          </div>
          <div className="event-banner-actions">
            <Link to="/events" className="btn-banner-primary">
              Join Now
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
            <Link to="/events" className="btn-banner-secondary">
              Read Details
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventBanner;
